import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'td-wb-joyride-close-button',
  templateUrl: './joyride-close-button.component.html',
  styleUrls: ['./joyride-close-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JoyrideCloseButtonComponent {
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  onClick(): void {
    this.clicked.emit();
  }
}
